"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveSpecificEffectEffectHandler = exports.RemoveSpecificEffectEffectArgs = void 0;
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class RemoveSpecificEffectEffectArgs {
    constructor(effectId) {
        this.effectId = effectId;
        this.__type = EffectType_1.EffectType.RemoveSpecificEffect;
        this.__typeName = "RemoveSpecificEffect";
        this.name = "Remove Effect";
        this.harmful = false;
    }
}
exports.RemoveSpecificEffectEffectArgs = RemoveSpecificEffectEffectArgs;
let RemoveSpecificEffectEffectHandler = class RemoveSpecificEffectEffectHandler {
    apply(sequence, container, state) {
        container.cancelEffect(sequence, state.args.effectId);
    }
    remove(sequence, container, state) {
        // TODO: do we want to support this?
    }
};
RemoveSpecificEffectEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.RemoveSpecificEffect)
], RemoveSpecificEffectEffectHandler);
exports.RemoveSpecificEffectEffectHandler = RemoveSpecificEffectEffectHandler;
